import { render, staticRenderFns } from "./VSearch.vue?vue&type=template&id=09aad672&"
import script from "./VSearch.vue?vue&type=script&lang=ts&"
export * from "./VSearch.vue?vue&type=script&lang=ts&"
import style0 from "./VSearch.vue?vue&type=style&index=0&id=09aad672&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports